<template>
  <article class="section-cart-item">
    <header class="section-cart-item__row">
      <div class="section-cart-item__heading">
        <a class="section-cart-item__heading__title" v-if="hasHeaderTitle">
          <slot name="headerTitle"></slot>
        </a>
        <div class="section-cart-item__heading__subtitle" v-if="hasHeaderSubtitle">
          <slot name="footerItems"></slot>
          -
          <slot name="headerSubtitle"></slot>
        </div>


        <div class="section-cart-item__heading__eyebrow" v-if="hasHeaderEyebrow">
          <slot name="headerEyebrow"></slot>
        </div>
      </div>

      <div class="section-cart-item__price">
        <div class="price">
          <slot name="footerPrice"></slot>
        </div>
      </div>
    </header>

    <slot></slot>

    <div class="section-cart-item__console">
      <slot name="console"></slot>
    </div>
  </article>

</template>

<script>
export default {
  props: ['editRouteParams'],

  computed: {
    hasHeaderEyebrow() {
      return !!this.$slots.headerEyebrow
    },

    hasHeaderTitle() {
      return !!this.$slots.headerTitle
    },

    hasHeaderSubtitle() {
      return !!this.$slots.headerSubtitle
    }
  }
}
</script>
